import React from 'react';
import ApiSauce, { CancelToken, ApiResponse } from 'apisauce';
import ApiConfig from '../../services/config/ApiConfig';
import { IStandardSummaryRequest } from './common';
const ndot_logo = require('../../assets/ndor_logo.png');
import "./summary.module.css"

export interface StandardSummaryFatalityReportRecord {
  dayOfMonth: string;
  name: string;
  age: string,
  sex: string;
  description: string;
  county: string;
  city: string;
  crashLocation: string;
  lightCondition: string;
  firstHarmfulEvent: string;
}

interface Props {
  apiToken: string;
  ssRequest: IStandardSummaryRequest;
}

interface State {
  hasData: boolean;
  fatalitiesReportData: { month: string, year: number, fatalities: StandardSummaryFatalityReportRecord[] };
}

const api = ApiSauce.create({
  ...ApiConfig,
  cancelToken: CancelToken.source().token,
});

export default class TrafficFatalitiesReport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    console.log({ props });

    this.state = {
      hasData: false,
      fatalitiesReportData: null,
    };

    api.setHeader('Authorization', props.apiToken);
  }

  componentDidMount(): void {
    api.post(`StandardSummary/FatalityReportData`, { ...this.props.ssRequest })
      .then((result: ApiResponse<any>) => {
        if (result.ok) {
          this.setState({
            fatalitiesReportData: result.data,
            hasData: true,
          });
        }
      });
  }

  render() {
    const { fatalitiesReportData } = this.state;

    return (
      <>
        <div className='page-break' style={{ margin: '10px auto' }}>
          <header>
            <div>
              <p>Report date: {Intl.DateTimeFormat('sv-SE').format(new Date())}</p>
            </div>
            <div style={{ textAlign: "center" }}>
              <p>STATE OF NEBRASKA</p>
              <p>TRAFFIC FATALITIES</p>
              <p>For {fatalitiesReportData?.month} {fatalitiesReportData?.year}</p>
            </div>
            <div className="logo">
              <img
                src={ndot_logo}
                alt="Nebraska Department of Roads"
              />
            </div>
          </header>
          <table className="fatalities-table" style={{ width: "100%", marginTop: 10 }}>
            <thead>
              <tr style={{ verticalAlign: 'bottom' }}>
                <th style={{ textAlign: 'center' }}>DAY<br />OF<br />MONTH</th>
                <th>NAME</th>
                <th style={{ textAlign: 'center' }}>AGE</th>
                <th style={{ textAlign: 'center' }}>SEX</th>
                <th>DESC</th>
                <th>COUNTY</th>
                <th>CITY</th>
                <th>CRASH LOCATION</th>
                <th>LIGHT<br />COND</th>
                <th>FIRST<br />HARMFUL<br />EVENT</th>
              </tr>
            </thead>
            <tbody>
              {fatalitiesReportData?.fatalities?.map(fatality => (
                <tr>
                  <td style={{ textAlign: 'center' }}>{fatality.dayOfMonth}</td>
                  <td>{fatality.name}</td>
                  <td style={{ textAlign: 'center' }}>{fatality.age}</td>
                  <td style={{ textAlign: 'center' }}>{fatality.sex}</td>
                  <td>{fatality.description}</td>
                  <td>{fatality.county.toUpperCase()}</td>
                  <td>{fatality.city.toUpperCase()}</td>
                  <td>{fatality.crashLocation}</td>
                  <td>{fatality.lightCondition}</td>
                  <td>{fatality.firstHarmfulEvent}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {this.state.hasData && <div id="allDataReceived"></div>}
      </>
    )
  }
}